export enum NavigationEndpoint {
  recordings = 'recordings',
  clips = 'clips',
  highlights = 'highlights',
  text = 'text',
  social = 'social',
  blog = 'blog',
  email = 'email',
  takeaways = 'takeaways',
  custom = 'custom'
}
